export default __webpack_public_path__ + "static/media/php.808faf65.svg";